import React from 'react';
import PropTypes from 'prop-types';
import { StarOutlineIcon } from '@domain-group/fe-co-icon';
import * as styles from './primary-feature.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var PrimaryFeature = _ref => {
  var title = _ref.title,
    description = _ref.description;
  return ___EmotionJSX("div", {
    css: styles.primaryFeature
  }, ___EmotionJSX("div", {
    css: styles.iconWrapper
  }, ___EmotionJSX(StarOutlineIcon, {
    css: styles.icon
  })), ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.description
  }, description)));
};
export var PrimaryFeaturePropTypes = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string
}).isRequired;
PrimaryFeature.propTypes = PrimaryFeaturePropTypes;
PrimaryFeature.defaultProps = {
  title: '',
  description: ''
};